module.exports = __webpack_public_path__ + "static/media/olivia.5b60d013.png";